import { FxAlert, FxButton } from '@/components/fx'

import { ProjektDialog } from './ProjektDialog'
import { templateCountLabel } from './projectData'

/**
 * What deleting a project actually does, said out loud.
 *
 * The gateway does **not** refuse a non-empty project: `DeleteFolder` removes
 * the folder row and `form_documents.folder_id` is `ON DELETE SET NULL`, so
 * the forms survive and reappear under "Ohne Projekt". The Flutter app
 * refuses the delete client-side (`FolderNotEmptyException`) to stand in for
 * a backend rule that does not exist — which means it forbids something the
 * server would happily do and teaches people a rule that is not real.
 *
 * So this confirms instead of refusing, and names the consequence with the
 * count. Nothing is lost by it, which is exactly why a refusal was the wrong
 * shape.
 */
export function DeleteFolderDialog({
  open,
  name,
  templateCount,
  pending,
  error,
  onConfirm,
  onOpenChange,
}: {
  open: boolean
  name: string
  templateCount: number
  pending?: boolean
  error?: string | null
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
}) {
  return (
    <ProjektDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Projekt löschen"
      description={
        templateCount > 0 ? (
          <>
            „{name}“ wird gelöscht. Die {templateCountLabel(templateCount)} darin{' '}
            <strong className="text-body-strong text-text">bleiben erhalten</strong> und stehen
            danach unter „Ohne Projekt“.
          </>
        ) : (
          <>„{name}“ wird gelöscht. Das Projekt ist leer.</>
        )
      }
      footer={
        <>
          <FxButton variant="outlined" onClick={() => onOpenChange(false)}>
            Abbrechen
          </FxButton>
          <FxButton variant="danger" disabled={pending} onClick={onConfirm}>
            Projekt löschen
          </FxButton>
        </>
      }
    >
      {error && <FxAlert tone="danger">{error}</FxAlert>}
    </ProjektDialog>
  )
}
